module.exports = __webpack_public_path__ + "static/img/guarana-zero.1739549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/guarana-zero.png
// module id = BJrs
// module chunks = 0